import { toastr } from 'react-redux-toastr'
import * as ActionTypes from '../../actions/actionTypes'
import * as actions from '../../actions/hostelWorldActions'
import { getParser } from '../../adapters'
import { urlParams } from '../../utils/mainUtils'
import { handleError, handleResponse, securedFetch, showImportCategoriesToastr } from '../apiUtils'
import * as urls from '../urls'

/** @thunk **/
export const fetchHwCategories = params => (dispatch, getState) => {
    dispatch({ type: ActionTypes.HW_CATEGORIES_FETCH_REQUEST })
    const { auth } = getState()

    securedFetch(urlParams(urls.hwCategoriesFind, params), auth, { method: 'GET' })
        .then(handleResponse)
        .then(json => dispatch(actions.hw_fetchCategoriesSuccess(getParser(urls.hwCategories)(json))))
        .catch(
            handleError(
                dispatch,
                actions.hw_fetchCategoriesFailure,
                'Что-то пошло не так!',
                'При получении категорий произошла ошибка'
            )
        )
}

/** @thunk **/
export const postHwCategory = category => (dispatch, getState) => {
    const opts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(category)
    }
    const { auth } = getState()

    securedFetch(urls.hwCategories, auth, opts)
        .then(handleResponse)
        .then(json => dispatch(actions.hw_saveCategoriesSuccess(json)))
        .then(() => toastr.success('Категория успешно сохранена'))
        .catch(
            handleError(
                dispatch,
                actions.hw_saveCategoriesFailure,
                'Что-то пошло не так!',
                'При сохранении категорий произошла ошибка'
            )
        )
}

/** @thunk **/
export const deleteHwCategory = remoteId => (dispatch, getState) => {
    const { auth } = getState()

    securedFetch(urls.hwCategorySelf(remoteId), auth, { method: 'DELETE' })
        .then(handleResponse)
        .then(() => dispatch(actions.hw_deleteCategorySuccess(remoteId)))
        .then(() => toastr.success('Категория удалена'))
        .catch(
            handleError(
                dispatch,
                actions.hw_deleteCategoryFailure,
                'Что-то пошло не так!',
                'При удалении категории произошла ошибка'
            )
        )
}

/** @thunk **/
export const importHwCategories = () => (dispatch, getState) => {
    const { auth, hwCurrentOrganization } = getState()

    const opts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ organizationId: hwCurrentOrganization })
    }

    securedFetch(urls.reloadCategoriesFromHw, auth, opts)
        .then(handleResponse)
        .then(showImportCategoriesToastr)
        .then(json => dispatch(actions.hw_importCategoriesSuccess(getParser(urls.reloadCategoriesFromHw)(json))))
        .catch(
            handleError(
                dispatch,
                actions.hw_importCategoriesFailure,
                'Что-то пошло не так!',
                'При импорте категорий произошла ошибка'
            )
        )
}



// WEBPACK FOOTER //
// ./src/api/hostelWorldApi/hwCategories.js